import Image from "next/image";
import Meta from "@/components/templates/Meta";
import { Header } from "@/components/templates/Header";
import { Footer } from "@/components/templates/Footer";
import Layout from "@/components/templates/Layout";
import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import { TLink } from "@/components/molecules/Button";
import { useBudouX } from "@/hooks/useBudouX";
import { BreadCrumb } from "@/components/organisms/BreadCrumb";
import Contact from "@/components/organisms/Contact";
import { Interviewee, Interviewer } from "@/components/organisms/InterviewItem";
import { VoiceCover } from "@/components/organisms/VoiceCover";
import { VoiceNav } from "@/components/organisms/VoiceNav";
import voicePhoto from "/public/voice-photo5.webp";
import voicePhotoB from "/public/voice-photo5b.webp";

export default function CareerArticle5(props) {
  const { parse } = useBudouX();
  const isHeaderRelative = true;
  return (
    <>
      <Meta
        pageTitle={
          "Voices:メンバーの声 No.5 柔軟に物事を決めていくスタンスに惹かれて"
        }
        pageDescription={
          "株式会社トッカシステムズのVoices:メンバーの声 No.5 柔軟に物事を決めていくスタンスに惹かれて。日進月歩のデジタルテクノロジー分野において『お客様のビジネスに特化（Tocca）したシステムを』という理念を社名に込めて、使える・価値のあるシステムを提供します。"
        }
        pagePath={"https://tocca.systems/careers/voice/5"}
      />
      <Layout className="relative">
        <div className="absolute z-0 aspect-1/1 w-full bg-voices-no5 xs:max-h-[300px] sm:max-h-[300px] md:aspect-1/1 md:max-h-[500px] lg:max-h-[640px]"></div>
        <Header isRelative={isHeaderRelative} />
        <main className="z-10 flex-1">
          <Container>
            <BreadCrumb
              lists={[
                {
                  name: "TOP",
                  path: "/",
                },
                {
                  name: "Careers",
                  path: "/",
                },
                {
                  name: "Voices:メンバーの声 No.5",
                },
              ]}
            />
            <Inner className="max-w-full">
              <div className="mx-auto flex max-w-6xl flex-col">
                <VoiceCover
                  title="柔軟に物事を決めていくスタンスに惹かれて"
                  avatar="D.Yさん - 2012年入社"
                />
                <figure className="relative mt-6 block aspect-2/1 w-full group-hover:opacity-80 md:mt-8 lg:mt-10">
                  <Image
                    src={voicePhoto}
                    alt="柔軟に物事を決めていくスタンスに惹かれて D.Yさん - 2012年入社"
                    quality={80}
                    layout="fill"
                    objectFit="cover"
                  />
                </figure>
              </div>
              <div
                className="mx-auto
                max-w-2xl
                space-y-3
                py-6
                leading-loose
                text-txt-base
                md:space-y-4
                md:py-8
                lg:space-y-6
                lg:pt-14
                lg:pb-20"
              >
                <Interviewer>D.Yさんが入社したのはいつですか?</Interviewer>
                <Interviewee>
                  私は、2012年からです。大学の掲示板でToccaSystemsのアルバイト募集がきっかけで、最初はアルバイトとして働き始めて、その後、新卒で入社しました。
                </Interviewee>
                <Interviewer>
                  大学生のアルバイトからToccaSystemsに入ったんですね。その時の印象覚えていますか。
                </Interviewer>
                <Interviewee>
                  そうですね、自由な空間だなと思いました。実際に働いてみて、柔軟に物事を受け入れ、仕事を進めていくところにとても惹かれたので、そのまま入社しました。
                </Interviewee>
                <Interviewer>
                  アルバイト時代からシステムの技術はあったのですか？
                </Interviewer>
                <Interviewee>
                  アルバイト時代はhtmlしかできなかったです。でも社員登用の際に3ヶ月の研修に参加して、プログラム開発の技術習得したり、OJTでも技術が身につきました。今ではプロジェクトのどのレイヤーを振られても、広く動けるところが自分の強みになりました。設計、開発、画面コーディング、マネージメント…器用貧乏のようですが、入社してから技術がたくさん身に付きましたね。
                </Interviewee>
                <div className="relative aspect-1.91/1">
                  <Image
                    src={voicePhotoB}
                    alt="【Voices: メンバーの声 No.5】 インタビューカット"
                    quality={80}
                    layout="fill"
                    objectFit="cover"
                  />
                </div>
                <Interviewer>
                  業務で、思い通りにいかないこともあると思うのですが、対処法を教えてください。
                </Interviewer>
                <Interviewee>
                  とりあえず手を動かします。対処できてるのかな…(笑)？
                  そういう時って、新たな気づきや学ぶことがすごくあるんですよね。
                  でも困った時は、先輩やまわりが助けてくれるので、とても助かっています。
                </Interviewee>
                <Interviewer>
                  仕事をしていて楽しいと思う瞬間を教えてください。
                </Interviewer>
                <Interviewee>
                  クライアントに喜ばれた時ですね。
                  クライアントからの反応には、毎回ドキドキしています。
                </Interviewee>
                <Interviewer>最後に1日の時間割を教えてください。</Interviewer>
                <div
                  className="flex
                  flex-col
                  gap-2
                  border
                  border-solid
                  border-bdc-light
                  bg-gray-50
                  py-6
                  px-8
                  leading-snug
                  fluid-text-[14px,16px]
                  md:gap-2
                  md:py-4
                  md:px-8
                  "
                >
                  <dl className="flex flex-col gap-0 md:flex-row md:gap-4">
                    <dt className="text-txt-light">09:00</dt>
                    <dd>出社</dd>
                  </dl>
                  <dl className="flex flex-col gap-0 md:flex-row md:gap-4">
                    <dt className="text-txt-light">09:15</dt>
                    <dd>
                      毎朝のプロジェクトグループの朝会があり、予定共有します。
                    </dd>
                  </dl>
                  <dl className="flex flex-col gap-0 md:flex-row md:gap-4">
                    <dt className="text-txt-light">10:00</dt>
                    <dd>
                      クライアントからの課題調査のタスク等の業務を行っています。
                    </dd>
                  </dl>
                  <dl className="flex flex-col gap-0 md:flex-row md:gap-4">
                    <dt className="text-txt-light">12:00</dt>
                    <dd>
                      お昼休憩は、会社の近所にランチの美味しいお店がたくさんあります！
                    </dd>
                  </dl>
                  <dl className="flex flex-col gap-0 md:flex-row md:gap-4">
                    <dt className="text-txt-light">13:00</dt>
                    <dd>
                      午後は、作業やクライアントとのミーティング等を行うことが多いです。
                    </dd>
                  </dl>
                  <dl className="flex flex-col gap-0 md:flex-row md:gap-4">
                    <dt className="text-txt-light">18:00</dt>
                    <dd>退社</dd>
                  </dl>
                </div>
                <Interviewee>
                  残業は、プロジェクトによってです。深夜にプロジェクトがリリースされる時は、次の日は定時より遅く出社できる制度を利用して調整します。代休や有給等の休暇がまとまって取得しやすいので、私は旅行によく行きます。今、日本酒にハマっているので、酒蔵巡りが楽しいです。
                </Interviewee>
                <div className="flex justify-end px-8 md:px-0">
                  <TLink href="/careers/" variant="mono" color="ff">
                    Carrers top
                  </TLink>
                </div>
              </div>
              <VoiceNav />
            </Inner>
          </Container>
        </main>
        <Contact />
        <Footer />
      </Layout>
    </>
  );
}
